(function () {
  function initCarousel(container) {
    if (container.dataset.instaInit === 'true') return;
    container.dataset.instaInit = 'true';

    var track = container.querySelector('.basiq-instagram-carousel__track');
    if (!track) return;

    var speedSeconds = parseFloat(container.dataset.speed) || 30;
    var position = 0;
    var lastTime = null;
    var thirdWidth = 0;
    var isPaused = false;

    function measure() {
      thirdWidth = track.scrollWidth / 3;
    }

    measure();
    window.addEventListener('resize', measure);

    function step(timestamp) {
      if (lastTime === null) lastTime = timestamp;
      var delta = timestamp - lastTime;
      lastTime = timestamp;

      if (!isPaused && thirdWidth > 0) {
        var pixelsPerMs = thirdWidth / (speedSeconds * 1000);
        position += pixelsPerMs * delta;

        if (position >= thirdWidth) {
          position -= thirdWidth;
        }

        track.style.transform = 'translateX(' + (-position) + 'px)';
      }

      requestAnimationFrame(step);
    }

    requestAnimationFrame(step);

    container.addEventListener('mouseenter', function () {
      isPaused = true;
      container.classList.add('is-hovering');
    });

    container.addEventListener('mouseleave', function () {
      isPaused = false;
      lastTime = null;
      container.classList.remove('is-hovering');
    });
  }

  function initAll() {
    document.querySelectorAll('.basiq-instagram-carousel').forEach(initCarousel);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();